import React, { useState } from 'react';
import './Top100.css';

const Top100 = () => {
    return (
        <div>
            <h1>Top 100 보여질 예정!</h1>
        </div>
    );
};

export default Top100;